const zh = {
  "site.title": "茶歇笔记",
  "header.blog": "博客",
  "header.resume": "简历",
  "footer.builtWith": "Built with",
  "footer.createdBy": "Created by Felix",
  "home.latestPosts": "最新博客",
  "home.more": "更多>>",
  "home.headTitle": "首页",
  "blogList.headTitle": "博客列表",
  "notFound.title": "NOT FOUND",
  "notFound.message": "你访问的页面不存在……",
  "notFound.headTitle": "404: 未找到",
  "cc.text": "本作品采用",
  "cc.licenseName":
    "知识共享署名4.0署名-非商业性使用-禁止演绎(BY-NC-ND)国际许可协议",
  "cc.suffix":
    "进行许可，转载时请注明原文链接，图片在使用时请保留全部内容，但不得对本创作进行修改，亦不得依据本创作进行再创作，不得将本创作运用于商业用途。",
  "lang.label": "中文",
} as const;

export default zh;
